import { useMutation } from 'react-query';
import { APPLY_API } from '../../../config';
import { ApplicationFormValues } from '../model';
import { serialize } from 'object-to-formdata';
import { pushTagManagerEvent, TagManagerEvent } from '../../../utils/loadTagManager.ts';
import { useAdvert } from './useAdvert.ts';

const URL_SEARCH_PARAMS = Object.fromEntries(new URLSearchParams(location.search.slice(1)));
const UTM_SOURCE = window.location.pathname.substring(1).split('/')[1];

export const useApplyMutation = (advertId: string) => {
  const { template } = useAdvert(advertId);

  return useMutation({
    mutationFn: async (payload: ApplicationFormValues) => {
      const response = await fetch(APPLY_API.replace('{advertId}', advertId), {
        method: 'POST',
        body: serialize(
          {
            ...payload,
            utm_source: UTM_SOURCE,
            meta: URL_SEARCH_PARAMS,
          },
          {
            indices: true,
          },
        ),
      });

      if (!response.ok) {
        return Promise.reject(response.status);
      }

      return (await response.json()) as Promise<{
        response?: object;
        employeeUrl: string | null;
      }>;
    },
    onSuccess: (_, variables) => {
      pushTagManagerEvent(TagManagerEvent.FORM_SUBMIT, {
        company: template,
        advertId,
        utmSource: UTM_SOURCE,
        formValues: variables,
      });
    },
  });
};
